import { Reveal, Eyebrow } from "./Reveal";

const STEPS = [
  {
    n: "01",
    title: "Inquire",
    copy: "Tell me about your occasion, date and the look you're envisioning.",
  },
  {
    n: "02",
    title: "Consult",
    copy: "We'll discuss your preferences, outfit, event and the overall look you're going for.",
  },
  {
    n: "03",
    title: "Get Glam",
    copy: "Relax and enjoy your experience while your final look comes together.",
  },
];

export const Experience = () => (
  <section id="experience" data-testid="section-experience" className="py-24 sm:py-32 bg-[#221019] text-[#F4E9DE]">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal className="mb-16">
        <p className="text-[11px] uppercase tracking-[0.3em] font-medium text-[#D4A960] flex items-center gap-3">
          <span className="font-serif-ed italic text-sm tracking-normal">05</span>
          <span className="h-px w-8 bg-[#D4A960]/60" aria-hidden="true" />
          The Experience
        </p>
        <h2 className="font-serif-ed font-normal text-3xl sm:text-4xl lg:text-5xl mt-6">
          Your Beauty, <em className="text-[#DA8A97]">Your Way</em>
        </h2>
      </Reveal>

      <div className="grid md:grid-cols-3 gap-10 md:gap-8">
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.12}>
            <div data-testid={`experience-step-${i + 1}`} className="border-t border-[#F4E9DE]/15 pt-8 group">
              <span className="font-serif-ed italic text-5xl sm:text-6xl text-[#D4A960]/40 group-hover:text-[#D4A960] transition-colors duration-700">
                {s.n}
              </span>
              <h3 className="mt-5 text-[12px] uppercase tracking-[0.3em] font-semibold">{s.title}</h3>
              <p className="mt-4 text-sm leading-relaxed text-[#F4E9DE]/60 max-w-xs">{s.copy}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
